import { render, staticRenderFns } from "./OzAlertDialogBox.vue?vue&type=template&id=d519ab90&"
import script from "./OzAlertDialogBox.vue?vue&type=script&lang=ts&"
export * from "./OzAlertDialogBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports